import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { TypedUseSelectorHook, useSelector } from "react-redux";
import dashboardSlice from "../modules/mainDashboard/src/redux/slices/dashboardSlice";
import LoginSlice from "../modules/login/redux/loginSlice";
import AmenitiesStateSlice from "../modules/stepper/redux/amenitesSlice";
import StepperSlice from "../modules/stepper/redux/stepperSlice";
import userRegistrationSlice from "../modules/signup/redux/userRegistrationSlice";
import userRegisterSlice from "../modules/register/redux/registerSlice";
import SiteRoadwaysSlice from "../modules/stepper/redux/siteRoadwaysSlice";
import loadingReducer from "./slices/loading";
import uiSlice from "../store/slices/uiSlice";
import ProfileSlice from "../modules/profile/redux/profileSlice";
import PreviewSlice from "../modules/application-section/application-preview/redux/previewSlice";
import UploadDocumentSlice from "@modules/application-section/application-preview/redux/UploadDocumentSlice";
import DetailsSlice from "@modules/application-section/application-details/redux/detailsSlice";
import ApplicationDetailsROWSlice from "@modules/application-section-row/application-details-row/redux/applicationDetailsROWSlice";
import AmenitiesStateROWSlice from "@modules/stepper-row/redux/amenitesROWSlice";
import SiteRoadwaysROWSlice from "@modules/stepper-row/redux/siteRoadwaysROWSlice";
import StepperROWSlice from "@modules/stepper-row/redux/stepperROWSlice";
import PreviewROWSlice from "@modules/application-section-row/application-preview/redux/previewROWSlice";
import ApplicationDashboardSlice from "@modules/application-section/application-dashboard/redux/slices/dashboardSlice";
import paymentSlice from "@store/slices/paymentSlice";
import feesDetailsReducer from "@modules/application-section/application-details/redux/feesDetailsSlice";
import ApplicationSubmittedSlice from "@modules/application-section/application-details/redux/applicationSubmittedSlice";
import GISDataSlice from "@gis/redux/gisSlice";
import ticketReducer from "../modules/helpdesk/redux/ticketSlice";
import guidelinesSlice from "@modules/public-comments/redux/guidelinesSlice";
import notificationsSlice from "@modules/public-comments/redux/notificationsSlice";
import legacySlice from "@modules/legacy-application-update/redux/slice/legacySlice";
import clarificationSlice from "@components/slider/redux/clarificationSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "stepper",
    "amenities",
    "siteRoadways",
    "amenitiesROW",
    "siteRoadwaysROW",
    "stepperROW",
    "login",
    "applicationDashboard",
    "register",
    "guidelines",
    "notifications",
    "clarification"
  ],
};
const rootReducer = combineReducers({
  login: LoginSlice,
  amenities: AmenitiesStateSlice,
  siteRoadways: SiteRoadwaysSlice,
  loading: loadingReducer,
  dashboardSlice: dashboardSlice,
  stepper: StepperSlice,
  uiData: uiSlice,
  userRegistration: userRegistrationSlice,
  profile: ProfileSlice,
  applicationPreview: PreviewSlice,
  uploadedDocuments: UploadDocumentSlice,
  applicationDetails: DetailsSlice,
  amenitiesROW: AmenitiesStateROWSlice,
  siteRoadwaysROW: SiteRoadwaysROWSlice,
  stepperROW: StepperROWSlice,
  applicationPreviewROW: PreviewROWSlice,
  payment: paymentSlice,
  applicationDetailsROW: ApplicationDetailsROWSlice,
  applicationDashboard: ApplicationDashboardSlice,
  register: userRegisterSlice,
  feesDetails: feesDetailsReducer,
  gisData: GISDataSlice,
  tickets: ticketReducer,
  isApplicationSubmitted: ApplicationSubmittedSlice,
  guidelines: guidelinesSlice,
  notifications: notificationsSlice,
  accessLegacy: legacySlice,
  clarification: clarificationSlice,
});

export type RootReducerType = ReturnType<typeof rootReducer>;

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
      // serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
